import {sort} from "@/helpers/common";

export async function getList({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.tags.getList();
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return commit('setList', []);
}

export async function getListById({commit},payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.tags.getListById(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return commit('setList', []);
}
export async function getLsTags({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.tags.getLsTags();
  if (!errResponse && responseData.success) {
    sort(responseData.data, 'id', 'desc');
    return commit('setLsTags', responseData.data);
  }

  return [];
}

export async function createTag({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.tags.create(payload);
  await dispatch('getList');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateTag({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.tags.update(payload.id, payload);
  await dispatch('getList');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findTagById({commit}, payload) {
  return await this.$frontendRepositories.tags.show(payload);
}

export async function deleteTag({commit}, id) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.tags.delete(id);

  if(!errResponse) {
    commit('deleteTag', id);

    return responseData;
  }

  return null;
}